import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Accordion, Card, Col, Row, Button } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';
import { useHistory } from 'react-router-dom';
import { SimpleCenteredModal } from '../../Utils/Modal';
import { sendAlert } from '../../../actions/utils';
import { updateEmployeeRequest } from '../../../requests/employees';
import Icon from '../../Icons';
import EmployeeQuickEdit from '../../../screens/Employee/EmployeeForm/EmployeeQuickEdit';
import { useAuthorization } from '../../../services/hooks';

const ContactData = ({ employee, activeAccordion, activeKey, employeeProfile }) => {
  const { email, fullAddress, parsedPhone, parsedWorkPhone, workEmail } = employee;

  const history = useHistory();

  const canRecordCard = useAuthorization('update_as_employee', 'Employee');

  const canUpdateData = employeeProfile && canRecordCard;

  const onlyIconButton = {
    padding: '0.2rem'
  };

  const [modalShow, setModalShow] = useState(false);
  const [fieldType, setFieldType] = useState('');
  const dispatch = useDispatch();

  const handleShowModal = field => {
    setFieldType(field);
    setModalShow(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleSuccessUpdate = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Trabajador actualizado con éxito' }));
    setModalShow(false);
    history.go(0);
  };

  const pickVariables = (_employee = {}, ...params) => ({
    ...params.reduce((prev, current) => ({ ...prev, [current]: _employee[current] }), {})
  });

  const handleUpdateRequest = (employeeValues, setSubmitting) => {
    const { employee: copyEmployee } = employeeValues;

    let myParams = {
      employee: { ...copyEmployee }
    };
    const keepVariables = {
      email: ['email'],
      phone: ['phoneCountryCode', 'phone'],
      address: ['address', 'addressNumber', 'addressApt', 'communeId', 'regionId']
    };

    myParams.employee = {
      ...pickVariables(myParams.employee, ...keepVariables[fieldType]),
      sendEmailUdpatedEmployee: true
    };

    myParams = snakeCaseKeys(myParams, {
      exclude: ['_destroy']
    });

    updateEmployeeRequest(employee.id, {
      dispatch,
      params: myParams,
      formData: true,
      successCallback: handleSuccessUpdate,
      callback: () => setSubmitting(false)
    });
  };

  return (
    <Card className="mr-2">
      <Col className={`${activeKey === 'contact-data' ? 'top-header-green' : 'top-header-light-gray'} br-5`}>
        <Accordion.Toggle as={Col} eventKey="1" onClick={activeAccordion} className="card-header-title">
          Información de Contacto
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="1">
        <Card.Body className="personal-data">
          <Row className="mt-3">
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Teléfono Laboral:</span>
                <span className={`answer ${!parsedWorkPhone ? 'text-grey' : ''}`}>
                  {parsedWorkPhone || 'No Aplica'}
                </span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Teléfono Personal:</span>
                <span className={`answer d-flex align-items-center ${!parsedPhone ? 'text-grey' : ''}`}>
                  {parsedPhone || 'No Aplica'}
                  {canUpdateData && (
                    <Button size="sm" className="ml-2" style={onlyIconButton} onClick={() => handleShowModal('phone')}>
                      <Icon icon="pencil" className="icon-15" />
                    </Button>
                  )}
                </span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">E-mail Laboral:</span>
                <span className={`answer ${!workEmail ? 'text-grey' : ''}`}>{workEmail || 'No Aplica'}</span>
              </div>
            </Col>
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Email Personal:</span>
                <span className={`answer d-flex align-items-center ${!email ? 'text-grey' : ''}`}>
                  {email || 'No Aplica'}
                  {canUpdateData && (
                    <Button size="sm" className="ml-2" style={onlyIconButton} onClick={() => handleShowModal('email')}>
                      <Icon icon="pencil" className="icon-15" />
                    </Button>
                  )}
                </span>
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={3}>
              <div className="d-flex flex-column mb-3">
                <span className="type">Dirección:</span>
                <span className={`answer d-flex align-items-center ${!fullAddress ? 'text-grey' : ''}`}>
                  {fullAddress || 'No Aplica'}
                  {canUpdateData && (
                    <Button
                      size="sm"
                      className="ml-2"
                      style={onlyIconButton}
                      onClick={() => handleShowModal('address')}
                    >
                      <Icon icon="pencil" className="icon-15" />
                    </Button>
                  )}
                </span>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Accordion.Collapse>

      <SimpleCenteredModal
        title="Datos de contacto"
        body={
          <EmployeeQuickEdit
            fieldType={fieldType}
            employee={employee}
            formRequest={handleUpdateRequest}
            handleModalClose={handleModalClose}
            dispatch={dispatch}
          />
        }
        show={modalShow}
        centered
        size="lg"
        onHide={() => setModalShow(false)}
      />
    </Card>
  );
};

export default ContactData;
